import { useGridApiContext as useCommunityGridApiContext } from '@mui/x-data-grid';
export const useGridApiContext = useCommunityGridApiContext;